import { InjectionKey } from 'vue'
import { createStore, Store } from 'vuex'
import { auth } from './modules/auth'
import { user } from './modules/user'
import { files } from './modules/files'
import { documentCounts } from './modules/documentCounts'

const modules = {
  auth,
  user,
  files,
  documentCounts,
}

export const key: InjectionKey<Store<typeof modules>> = Symbol()

const store = createStore<typeof modules>({
  modules,
})

export default store
